module.exports = __webpack_public_path__ + "img/sGoldenFa_350x350.3475b772.jpg";